<template>
  <div>
    <remittances-report>

    </remittances-report>
  </div>
</template>
<script>
  import RemittancesReport from './RemittancesReport'

  export default {
    components: {
      RemittancesReport,
    },
  }
</script>
